export default "__VITE_ASSET__Xtr3u_Vv__"